import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { theme } from "../../../../utils/global-styles/theme";

import BulletIcon from "../Assets/BulletIcon";

const RichTextListItem = ({ text }) => {
  const ListItemGrid = styled.div`
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 5% 1fr;
    height: max-content;
    margin: 1em 0 1em 1em;

    @media only screen and (max-width: ${theme.breakpoints.helper800}) {
      margin-left: 0;
      margin-right: 0;
    }
  `;

  const ListItemBullet = styled.div`
    grid-area: 1 / 1 / span 1 / span 1;
    padding-top: 0.5em;
  `;
  const ListItemTextContainer = styled.div`
    grid-area: 1 / 2 / span 1 / span 1;
  `;

  const RichText = styled.p`
    color: ${theme.colors.main};
    font-size: 20px;
    letter-spacing: -0.57px;
    line-height: 31px;

    @media only screen and (max-width: ${theme.breakpoints.helper800}) {
      margin-left: 12px;
    }
  `;

  return (
    <ListItemGrid>
      <ListItemBullet>
        <BulletIcon />
      </ListItemBullet>
      <ListItemTextContainer>
        <RichText>{text}</RichText>
      </ListItemTextContainer>
    </ListItemGrid>
  );
};

RichTextListItem.propTypes = {
  text: PropTypes.string,
};

export default RichTextListItem;
